export default {
  //
  getRaceRepalyData: "/race"
};